import {Component, inject} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {Router} from '@angular/router';

@Component({
  selector: 'app-not-found-page',
  standalone: true,
  imports: [
    MatButton
  ],
  templateUrl: './not-found-page.component.html',
  styleUrl: './not-found-page.component.scss'
})
export class NotFoundPageComponent {
  private router: Router = inject(Router);

  protected async goToHomePage(): Promise<void> {
    await this.router.navigate(['']);
  }
}
